export default function DestinationBody({ d }) {
  return (
    <div className="grid grid-cols-12 gap-6">
      <div className="col-span-12 md:col-span-4">
        <div className="eyebrow mb-4">The Land</div>
        <h3 className="font-serif text-3xl md:text-4xl font-light leading-tight">
          {d.intro}
        </h3>
      </div>
      <div className="col-span-12 md:col-span-7 md:col-start-6">
        <p className="text-lg text-ink/80 leading-[1.85] font-light">{d.long}</p>

        <div className="mt-12">
          <div className="eyebrow mb-6">Signature Moments</div>
          <ul className="space-y-4">
            {d.highlights?.map((h, i) => (
              <li
                key={h}
                className="flex items-baseline gap-5 border-b border-line-dark pb-4"
              >
                <span className="font-serif text-goldleaf text-xl">0{i + 1}</span>
                <span className="font-light text-ink/85">{h}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
